// BREAKFAST
import Lemonade from "../assets/images/lemon.png";
import BreadEgg from "../assets/images/bread.png";
import Oatmeal from "../assets/images/oatmeal.png";
import Fruit from "../assets/images/fruit.png";
import Juice from "../assets/images/juice.png";
import Berries from "../assets/images/berries.png";
import FruitSmoothie from "../assets/images/shake.png";
import TeaCookies from "../assets/images/tea-cookies.png";
import GreenTea from "../assets/images/green-tea.png";

// LUNCH
import MixSalad from "../assets/images/lunch-food.png";
import VegetableCurry from "../assets/images/lunch-food-vegetable.png";

// DINNER
import BeanSalad from "../assets/images/dinner-food.png";
import Milk from "../assets/images/milk-glass.png";
import Almonds from "../assets/images/almonds.png";

export const BreakfastData = [
  {
    id: 1,
    description: " ناشتے سے پہلے پانی یا لیموں پانی (نیم گرم پانی میں لیموں) پی لیں۔ پھر جَو کی روٹی کے ساتھ 1 انڈا (ترجیحی طور پر ابلا ہوا) ساتھ چائے/دودھ (کم چکنائی والا دودھ) ",
    image: Lemonade,
    text: " یا ",
  },
  {
    id: 2,
    description: " دودھ والا جَو کا دلیہ ",
    image: Oatmeal,
    text: " وسطی صبح ",
  },
  {
    id: 3,
    description: " اپنی پسند کے مطابق 1 پھل ",
    image: Fruit,
    text: " یا ",
  },
  {
    id: 4,
    description: " تازہ رس (پیک شدہ نہیں) ",
    image: Juice,
    text: " یا ",
  },
  {
    id: 5,
    description: " ½ کپ تازہ بیریز ",
    image: Berries,
    text: " یا ",
  },
  {
    id: 6,
    description: "  پھلوں کا شیک (وزن کم کرنے کے لیے سب سے زیادہ قابل ترجیح) (اس میں کم چکنائی والا دہی استعمال کریں) ",
    image: FruitSmoothie,
  },
]

export const LunchData = [
  {
    id: 1,
    description: " ایک کپ مکس سلاد (کھیرا، ٹماٹر، گوبھی شامل کریں پھر ذائقہ کے لیے ذرا سا لیموں کا رس اور کالی مرچ ڈال لیں) + 3 اونس بھُنا ہوا دیسی مرغی مچھلی/گوشت ",
    image: MixSalad,
    text: " یا ",
  },
  {
    id: 2,
    description: "  ک ½ کپ سبزیوں کا سالن/ دال 1 روٹی کے ساتھ۔ (پالک وزن کم کرنے میں مددگار ہے) بین سلاد کے ساتھ دوپہر کے کھانے میں کم چکنائی والا دہی بھی شامل کریں (اگر آپ پہلے فروٹ شیک پی چکے ہیں تو دوپہر کے کھانے میں ضروری نہیں ہے) اگر آپ چاول لینا چاہتے ہیں تو آپ سالن کے ساتھ ½ کپ ابلے ہوئے چاول لے سکتے ہیں۔ ",
    image: VegetableCurry,
  },
]

export const DinnerData = [
  {
    id: 1,
    description: " اگر پسند کرتے ہیں تو چائے ۱ یا ۲ بسکٹ کے ساتھ ",
    image: TeaCookies,
    text: " یا ",
  },
  {
    id: 2,
    description: " سبز چائے (دار چینی اور لیموں شامل کریں اور چینی کی بجائے شہد استعمال کریں) ",
    image: GreenTea,
    text: " رات کا کھانا ",
  },
  {
    id: 3,
    description: " بین سلاد (لوبیا، چنے، مٹر) ½ سبزی یا کسی دال کا سالن چھوٹی سی روٹی کے ساتھ۔ ",
    image: BeanSalad,
    text: " سونے کے وقت ",
  },
  {
    id: 4,
    description: " ایک گلاس دودھ (صرف کم چکنائی والا) ",
    image: Milk,
    text: " یا ",
  },
  {
    id: 5,
    description: " بادام ",
    image: Almonds,
  },
]